import { get, post, deleteRequest } from "../../../utils/request";


// 获取全部字典
export const getAllDictList = (params) => {
    return get('/dict/page', params)
};
// 添加字典
export const addDict = (params) => {
    return post('/dict/add', params)
};
// 编辑字典
export const editDict = (params) => {
    return post('/dict/edit', params)
};
// 删除字典
export const deleteDict = (ids, params) => {
    return deleteRequest(`/dict/delByIds/${ids}`, params)
};
// 搜索字典
export const searchDict = (params) => {
    return get('/dict/search', params)
};
// 获取全部字典数据
export const getAllDictDataList = (params) => {
    return get('/dictData/getByCondition', params)
};
// 添加字典数据
export const addDictData = (params) => {
    return post('/dictData/add', params)
};
// 编辑字典数据
export const editDictData = (params) => {
    return post('/dictData/edit', params)
};
// 删除字典数据
export const deleteData = (ids, params) => {
    return deleteRequest(`/dictData/delByIds/${ids}`, params)
};
// 通过类型获取字典数据。获取子字典
export const getDictDataByType = (type, params) => {
    return get(`/dictData/getDictDataByType?type=${type}`, params)
};